module.exports = __webpack_public_path__ + "img/about_logo.4503e442.png";